<template>
  <a class="arrow" @click.prevent="$router.go(-1)"><i class="xi-long-arrow-left"></i></a>
</template>

<script>
export default {
  name: 'RouteBack'
}
</script>



// WEBPACK FOOTER //
// src/components/RouteBack.vue